<template>
  <div>
    <TopBar :mode="mode" @toggle="$emit('toggle')">
      <span class="text-[21px] font-semibold custom:text-lg xl:hidden"
        >Subscription (Monthly)
        <span
          class="text-[15px] font-normal"
          :class="[mode === 'dark' ? 'text-dark-15' : 'text-gray-600']"
        >
          <a
            href="https://billing.stripe.com/p/login/dR6eVH4Nt7vz8OQ6oo"
            target="_"
            class="text-primary-100 hover:text-primary-100 hover:underline"
          >
            Update Your Form of Payment</a
          >,
          <a
            href="https://billing.stripe.com/p/login/dR6eVH4Nt7vz8OQ6oo"
            target="_"
            class="text-primary-100 hover:text-primary-100 hover:underline"
          >
            Download Invoices
          </a>
          and/or
          <a
            href="https://billing.stripe.com/p/login/dR6eVH4Nt7vz8OQ6oo"
            target="_"
            class="text-primary-100 hover:text-primary-100 hover:underline"
          >
            Cancel your Subscription
          </a>
        </span>
      </span>
    </TopBar>
    <div class="p-4">
      <div class="hidden items-center justify-between mb-4 xl:flex">
        <span class="text-[21px] font-semibold custom:text-lg"
          >Subscription (Monthly)
          <span
            class="text-[15px] font-normal"
            :class="[mode === 'dark' ? 'text-dark-15' : 'text-gray-600']"
          >
            <a
              href="https://billing.stripe.com/p/login/dR6eVH4Nt7vz8OQ6oo"
              target="_"
              class="text-primary-100 hover:text-primary-100 hover:underline"
            >
              Update Your Form of Payment</a
            >,
            <a
              href="https://billing.stripe.com/p/login/dR6eVH4Nt7vz8OQ6oo"
              target="_"
              class="text-primary-100 hover:text-primary-100 hover:underline"
            >
              Download Invoices
            </a>
            and/or
            <a
              href="https://billing.stripe.com/p/login/dR6eVH4Nt7vz8OQ6oo"
              target="_"
              class="text-primary-100 hover:text-primary-100 hover:underline"
            >
              Cancel your Subscription
            </a>
          </span>
        </span>
      </div>
      <div class="flex items-start gap-4 md:flex-col">
        <div
          class="rounded-xl shadow-card p-4 flex-1 md:w-full"
          :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
        >
          <h4 class="text-[17px] font-semibold leading-none mb-3">
            Full Plan - Complete On Page SEO AI Tool
          </h4>
          <div class="relative flex items-center">
            <select
              class="form-field appearance-none"
              @change="showBaiscPlansBenefits"
            >
              <option value="-1" disabled>Select a plan</option>
              <option
                v-for="(plan, key) in basicPlans"
                :key="key"
                :value="plan.tier_id"
                :selected="selectedBasicPlan?.tier_id === plan.tier_id"
              >
                {{ plan.pricing }} -
                {{ plan.benefits[0] }}
              </option>
            </select>
            <span class="absolute right-3 pointer-events-none">
              <ChevronDown :size="18" :stroke-width="1.75" />
            </span>
          </div>
          <div v-if="selectedBasicPlan" class="mt-3">
            <span class="font-bold text-[17px] block mb-2">You Get Today:</span>
            <ul class="grid gap-2">
              <li>
                <span class="font-medium mb-1 block"
                  >Full On-Page SEO Solution:
                  {{ selectedBasicPlan.benefits[1] }}</span
                >
                <ul class="list-disc pl-6 grid gap-1">
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Full On-Page SEO Solution:
                    {{ basicPlansCredits("spy", selectedBasicPlan.pricing) }}
                    Monthly Pages (Spy & audit reports)
                  </li>
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Advanced AI does ALL Your On-Page for You Automatically
                  </li>
                </ul>
              </li>
              <li>
                <span class="font-medium mb-1 block"
                  >Reduce ALL Your SEO Costs</span
                >
                <ul class="list-disc pl-6 grid gap-1">
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Save a TON of Time and Money on SEO Research/Writing
                  </li>
                </ul>
              </li>
              <li>
                <span class="font-medium mb-1 block"
                  >Advanced SEO Co-Pilot</span
                >
                <ul class="list-disc pl-6 grid gap-1">
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Find ALL your Boosting SEO Keywords on Auto-Pilot -
                    GUARANTEED to BOOST with AI analysis
                  </li>
                </ul>
              </li>
              <li>
                <span class="font-medium mb-1 block"
                  >{{
                    selectedBasicPlan.pricing !== "$54/month"
                      ? "A Whopping"
                      : ""
                  }}
                  Credits!</span
                >
                <ul class="list-disc pl-6 grid gap-1">
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    {{ basicPlansCredits("diff", selectedBasicPlan.pricing) }}
                    Keyword Difficulty Credits!
                  </li>
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    That’s about
                    {{ basicPlansCredits("kwd", selectedBasicPlan.pricing) }}
                    Keyword Discovery Reports, take on
                    {{ basicPlansCredits("kwd", selectedBasicPlan.pricing) }}
                    new ranking niches or clients per month!
                  </li>
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Discover the hidden Ranking Opportunities! Go for the
                    EASIEST to rank for searches that make YOU the most $$$
                  </li>
                </ul>
              </li>
              <li>
                <span class="font-medium mb-1 block">Spy on Competitors</span>
                <ul class="list-disc pl-6 grid gap-1">
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Better Competitive Edge: Use Smart AI to Spy on valuable
                    competitor metrics unlike any SEO app
                  </li>
                </ul>
              </li>
              <li>
                <span class="font-medium block">{{
                  selectedBasicPlan.price !== "874"
                    ? "1 User Access"
                    : "10 Users Access"
                }}</span>
              </li>
              <li>
                <span
                  class="font-semibold text-xl flex items-center justify-center gap-2"
                  >Win at SEO for ONLY:
                  <span
                    class="relative text-4xl pl-3 leading-none flex items-center gap-1"
                    ><sup class="absolute -top-[2px] left-0 text-base">$</sup
                    >{{ selectedBasicPlan.price }}
                    <span class="text-lg">/</span>
                    <sub class="text-base -bottom-[2px] leading-none"
                      >Month</sub
                    ></span
                  ></span
                >
              </li>
            </ul>
            <div class="mt-4 flex items-center gap-2 xs:flex-col">
              <input
                id="coupon-basic"
                placeholder="Enter a coupon"
                v-model="coupons[selectedBasicPlan.tier_id]"
                class="form-field w-auto xs:w-full"
                :disabled="basicPlanPaypal"
                :class="[
                  basicPlanPaypal ? 'opacity-70 !cursor-not-allowed' : '',
                ]"
              />
              <button
                class="button primary-button xs:w-full"
                @click="
                  subscribePlan(selectedBasicPlan, selectedBasicPlan.tier_id)
                "
                :class="[
                  coupons[selectedBasicPlan.tier_id] ? 'pulse-notif' : '',
                ]"
              >
                Subscribe with Credit/Debit Card
              </button>
              <button
                class="button bg-warning-100 text-black-100 hover:text-black-100 hover:brightness-125 xs:w-full"
                @click="subscribeWithPayPalPlan(selectedBasicPlan, 1)"
              >
                Subscribe with PayPal
              </button>
            </div>
            <div v-show="basicPlanPaypal" class="mt-4">
              <div
                :id="`paypal-btn-${selectedBasicPlan.price_id}`"
                class="paypal-btn-basic"
              ></div>
            </div>
          </div>
        </div>
        <div
          class="rounded-xl shadow-card p-4 flex-1 md:w-full"
          :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
        >
          <h4 class="text-[17px] font-semibold leading-none mb-3">
            Keyword Discovery - Niche Research Tool
          </h4>
          <div class="relative flex items-center">
            <select
              class="form-field appearance-none"
              @change="showkeywordDiscoveryPlansBenefits"
            >
              <option value="-1" disabled>Select a plan</option>
              <option
                v-for="(plan, key) in keywordDiscoveryPlans"
                :key="key"
                :value="plan.tier_id"
                :selected="
                  selectedKeywordDiscoveryPlan?.tier_id === plan.tier_id
                "
              >
                {{ plan.pricing }} - Data retention for 7 days
              </option>
            </select>
            <span class="absolute right-3 pointer-events-none">
              <ChevronDown :size="18" :stroke-width="1.75" />
            </span>
          </div>
          <div v-if="selectedKeywordDiscoveryPlan" class="mt-3">
            <ul class="grid gap-2">
              <li>
                <span class="font-medium mb-1 block"
                  >{{
                    kwdPlansCredits(
                      "diff",
                      selectedKeywordDiscoveryPlan.pricing
                    )
                  }}
                  Keyword Difficulty Credits</span
                >
                <ul class="list-disc pl-6 grid gap-1">
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    That’s about
                    {{
                      kwdPlansCredits(
                        "kwd",
                        selectedKeywordDiscoveryPlan.pricing
                      )
                    }}
                    Keyword Discovery Reports, take on
                    {{
                      kwdPlansCredits(
                        "kwd",
                        selectedKeywordDiscoveryPlan.pricing
                      )
                    }}
                    new ranking niches or clients per month!
                  </li>
                  <li
                    class="leading-normal"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Discovery the Ranking Opportunities in Your Niche, Go for
                    the best queries that make YOU the most money
                  </li>
                </ul>
              </li>
            </ul>
            <div class="mt-3 flex items-center gap-2 xs:flex-col">
              <input
                id="coupon-kwd"
                placeholder="Enter a coupon"
                v-model="coupons[selectedKeywordDiscoveryPlan.tier_id]"
                class="form-field w-auto xs:w-full"
                :disabled="kwdPlanPaypal"
                :class="[kwdPlanPaypal ? 'opacity-70 !cursor-not-allowed' : '']"
              />
              <button
                class="button primary-button xs:w-full"
                @click="
                  subscribePlan(
                    selectedKeywordDiscoveryPlan,
                    selectedKeywordDiscoveryPlan.tier_id
                  )
                "
                :class="[
                  coupons[selectedKeywordDiscoveryPlan.tier_id]
                    ? 'pulse-notif'
                    : '',
                ]"
              >
                Subscribe with Credit/Debit Card
              </button>
              <button
                class="button bg-warning-100 text-black-100 hover:text-black-100 hover:brightness-125 xs:w-full"
                @click="
                  subscribeWithPayPalPlan(selectedKeywordDiscoveryPlan, 2)
                "
              >
                Subscribe with PayPal
              </button>
            </div>
            <div v-show="kwdPlanPaypal" class="mt-4">
              <div
                :id="`paypal-btn-${selectedKeywordDiscoveryPlan.price_id}`"
                class="paypal-btn-kwd"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" class="flex items-center justify-end mt-4">
        <button @click="renewAppsumoCredits" class="button primary-button">
          Renew Appsumo Credits
        </button>
      </div>
    </div>
    <div
      v-if="showPaypalDiscountPopup"
      class="bg-opacity-40 fixed inset-0 z-[9999] flex items-center justify-center p-4"
      :class="mode === 'dark' ? 'bg-white-100' : 'bg-black-100'"
    >
      <div
        class="max-w-lg rounded-xl w-full mx-auto overflow-hidden"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
      >
        <div class="p-4">
          <div
            class="text-center flex items-center justify-center flex-col gap-4"
          >
            <p :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'">
              Sorry, our system can only offer discounts on Credit/Debit
              purchases at this time. Please click CANCEL and then click
              Credit/Debit purchase. Or continue payment on PayPal at our
              regular cost effective price.
            </p>
            <button
              class="button close-button"
              @click="showPaypalDiscountPopup = false"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";
import helper from "../libs/helper";
import { credits } from "../libs/data/credits";
import { useUserStore } from "../stores/user";
import ApiRequest from "../libs/ApiRequest";
import TopBar from "../components/TopBar.vue";
import { computed } from "@vue/reactivity";
import { ChevronDown } from "lucide-vue-next";
export default {
  setup() {
    const userStore = useUserStore();
    return { userStore, user: computed(() => userStore.user) };
  },
  props: {
    mode: String,
  },
  components: {
    TopBar,
    ChevronDown,
  },
  data() {
    return {
      plans: [],
      paypalSDK: null,
      paypalSubscribePlan: null,
      renderedPayPalButtonsForPlan: [],
      coupons: {},
      basicPlans: [],
      keywordDiscoveryPlans: [],
      selectedBasicPlan: null,
      selectedKeywordDiscoveryPlan: null,
      showPaypalDiscountPopup: false,
      basicPlanPaypal: false,
      kwdPlanPaypal: false,
      creditsList: [],
    };
  },
  async mounted() {
    this.loadPlans();
  },
  methods: {
    async loadPlans() {
      try {
        this.userStore.setIsLoading(!0);
        const { data } = await ApiRequest().get(`/api/payments/tier-list`);
        this.plans = data;
        this.creditsList = credits;
        this.basicPlans = this.plans
          .filter((plan) => plan.name.includes("Data Retention"))
          .filter(
            (plan, index, arr) =>
              arr.findIndex((p) => p.tier_id === plan.tier_id) === index
          )
          .sort((a, b) => a.price - b.price);
        this.keywordDiscoveryPlans = this.plans
          .filter(
            (plan) =>
              plan.name === "Keyword Discovery - Niche Research Tool" &&
              plan.price <= 44
          )
          .sort((a, b) => a.price - b.price);
        this.selectedBasicPlan = this.basicPlans[2];
        if (this.keywordDiscoveryPlans.length === 0) {
          this.selectedKeywordDiscoveryPlan = null;
        }
        if (this.keywordDiscoveryPlans.length === 1) {
          this.selectedKeywordDiscoveryPlan = this.keywordDiscoveryPlans[0];
        } else {
          this.selectedKeywordDiscoveryPlan = this.keywordDiscoveryPlans[1];
        }
        setTimeout(this.userStore.setIsLoading.bind(null, !1), 2000);
        const coupon = this.$route.query?.coupon;
        if (coupon) {
          this.plans.forEach((plan) => {
            this.coupons[plan.tier_id] = coupon;
          });
        }
        if (!this.$route.query) {
          return;
        }
        if (this.$route.query && this.$route.query.hasOwnProperty("plan")) {
          const planParam = this.$route.query["plan"].split("_")[0];
          const tierParam = this.$route.query["plan"].split("_")[1];
          if (planParam === "full") {
            this.selectedBasicPlan = this.basicPlans.find(
              (plan) => plan.tier_id === tierParam
            );
          } else if (planParam === "kwd") {
            this.selectedKeywordDiscoveryPlan = this.keywordDiscoveryPlans.find(
              (plan) => plan.tier_id === tierParam
            );
          }
          window.localStorage.removeItem("seo-plan");
        }
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "plans");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    async subscribePlan(plan, key) {
      try {
        this.userStore.setIsLoading(!0);
        const planDetails = plan;
        const { data } = await ApiRequest().post(`/api/payments/subscribe`, {
          ...planDetails,
          coupon: this.coupons[key],
        });
        if (data?.checkout_url) {
          this.$toast.success("Redirecting to payment");
          window.location.replace(data.checkout_url);
        } else {
          throw new Error("Something went wrong!");
        }
        this.userStore.setIsLoading(!1);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "subscription");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    subscribeWithPayPalPlan(plan, type) {
      if (type === 1) {
        if (document.getElementById("coupon-basic").value) {
          this.showPaypalDiscountPopup = true;
          return;
        }
        document.querySelector(".paypal-btn-basic").innerHTML = "";
        this.basicPlanPaypal = !this.basicPlanPaypal;
      }
      if (type === 2) {
        if (document.getElementById("coupon-kwd").value) {
          this.showPaypalDiscountPopup = true;
          return;
        }
        document.querySelector(".paypal-btn-kwd").innerHTML = "";
        this.kwdPlanPaypal = !this.kwdPlanPaypal;
      }
      this.paypalSubscribePlan = plan;
      this.renderedPayPalButtonsForPlan.push(plan);
      this.initPayPalBtn(plan);
    },
    async initPaypalSDK() {
      if (this.paypalSDK === null) {
        this.paypalSDK = await loadScript({
          "client-id": import.meta.env.VITE_PAYPAL_CLIENT_ID,
          vault: true,
          intent: "subscription",
        });
      }
    },
    async initPayPalBtn(plan) {
      try {
        await this.initPaypalSDK();
        const subscriptionData = {
          plan_id: plan.paypal_id,
          custom_id: JSON.stringify({
            email: this.user.email,
            tier_id: plan.tier_id,
          }),
        };
        this.paypalSDK
          .Buttons({
            createSubscription: function (data, actions) {
              return actions.subscription.create(subscriptionData);
            },
            onApprove: (data, actions) => {
              this.$router.push({ name: "subscription-confirmed" });
            },
            onCancel: (data, actions) => {
              this.$router.push({ name: "subscription-cancelled" });
            },
            onError: (err) => {
              console.log("paypal payment error", err);
              this.$toast.error("Something went wrong!");
            },
            style: {
              shape: "rect",
              color: "gold",
              layout: "vertical",
              label: "subscribe",
            },
          })
          .render(`#paypal-btn-${plan.price_id}`);
      } catch (error) {
        console.error("paypal button render error", error);
        this.$toast.error("Something went wrong!");
      }
    },
    showBaiscPlansBenefits($event) {
      if ($event.target.value === "-1") {
        this.selectedBasicPlan = null;
        return;
      }
      this.selectedBasicPlan = this.basicPlans.filter(
        (plan) => plan.tier_id === $event.target.value
      )[0];
      this.basicPlanPaypal = false;
    },
    showkeywordDiscoveryPlansBenefits($event) {
      if ($event.target.value === "-1") {
        this.selectedKeywordDiscoveryPlan = null;
        return;
      }
      this.selectedKeywordDiscoveryPlan = this.keywordDiscoveryPlans.filter(
        (plan) => plan.tier_id === $event.target.value
      )[0];
      this.kwdPlanPaypal = false;
    },
    async renewAppsumoCredits() {
      try {
        this.userStore.setIsLoading(!0);
        const { data } = await ApiRequest().get(
          `/api/auth/request-account-renewal`
        );
        if (data && data.success) {
          this.$toast.success("Your appsumo credits renewed successfully!");
        } else {
          throw new Error("Something went wrong!");
        }
        this.userStore.setIsLoading(!1);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(
          error,
          "renew appsumo credits"
        );
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    basicPlansCredits(type, pricing) {
      if (type === "spy") {
        return this.creditsList.find(
          (credit) =>
            credit.type === "Full Plan - Complete On Page SEO AI Tool" &&
            credit.pricing === pricing
        ).keywordSpyCredits;
      }
      if (type === "kwd") {
        return this.creditsList.find(
          (credit) =>
            credit.type === "Full Plan - Complete On Page SEO AI Tool" &&
            credit.pricing === pricing
        ).keywordDiscoveryCredits;
      }
      if (type === "diff") {
        return this.creditsList.find(
          (credit) =>
            credit.type === "Full Plan - Complete On Page SEO AI Tool" &&
            credit.pricing === pricing
        ).keywordDifficultyCredits;
      }
    },
    kwdPlansCredits(type, pricing) {
      if (type === "kwd") {
        return this.creditsList.find(
          (credit) =>
            credit.type === "Keyword Discovery - Niche Research Tool" &&
            credit.pricing === pricing
        ).keywordDiscoveryCredits;
      }
      if (type === "diff") {
        return this.creditsList.find(
          (credit) =>
            credit.type === "Keyword Discovery - Niche Research Tool" &&
            credit.pricing === pricing
        ).keywordDifficultyCredits;
      }
    },
  },
};
</script>
